export const NewTabIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none">
      <path
        d="M6.27123 1.44444H1.94281V11.5556H6.27123V1.44444ZM7.71404 1.44444V11.5556H12.0425V1.44444H7.71404ZM1.2214 0H12.7639C12.9552 0 13.1387 0.076091 13.274 0.211534C13.4093 0.346977 13.4853 0.530677 13.4853 0.722222V12.2778C13.4853 12.4693 13.4093 12.653 13.274 12.7885C13.1387 12.9239 12.9552 13 12.7639 13H1.2214C1.03008 13 0.846584 12.9239 0.711294 12.7885C0.576005 12.653 0.5 12.4693 0.5 12.2778V0.722222C0.5 0.530677 0.576005 0.346977 0.711294 0.211534C0.846584 0.076091 1.03008 0 1.2214 0Z"
        fill="#1B7FF1"
      />
      <rect x="1.94409" y="1.4458" width="10.0997" height="10.1111" fill="white" />
      <rect
        x="12.0421"
        width="1.44444"
        height="9.37825"
        rx="0.722222"
        transform="rotate(90 12.0421 0)"
        fill="white"
      />
      <rect
        x="4.10657"
        width="1.44444"
        height="2.88562"
        rx="0.722222"
        transform="rotate(90 4.10657 0)"
        fill="#1B7FF1"
      />
      <rect
        x="13.4852"
        y="12.2778"
        width="1.44281"
        height="9.38889"
        rx="0.721404"
        transform="rotate(-180 13.4852 12.2778)"
        fill="white"
      />
      <rect x="12.0421" y="9.39014" width="1.44281" height="2.88889" rx="0.721404" fill="#1B7FF1" />
      <path
        d="M12.0572 2.46567L6.35869 8.17063C6.07678 8.45286 5.61936 8.45287 5.33744 8.17063C5.05599 7.88886 5.05598 7.43235 5.33741 7.15056L11.0364 1.44444H6.28678C5.88791 1.44444 5.56456 1.12109 5.56456 0.722222C5.56456 0.32335 5.88791 0 6.28678 0H12.5C13.0523 0 13.5 0.447715 13.5 1V7.22304C13.5 7.62146 13.177 7.94444 12.7786 7.94444C12.3802 7.94444 12.0572 7.62146 12.0572 7.22304V2.46567Z"
        fill="#1B7FF1"
      />
    </svg>
  );
};
